import { render } from "./print-gaji-plt.vue?vue&type=template&id=fff5bfb4&scoped=true"
import script from "./print-gaji-plt.vue?vue&type=script&lang=js"
export * from "./print-gaji-plt.vue?vue&type=script&lang=js"

import "./print-gaji-plt.vue?vue&type=style&index=0&id=fff5bfb4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff5bfb4"]])

export default __exports__